import {
  appendAttorneyRequiredFields,
  appendHighBondAuthField,
} from "./bondFormValidationHelpers";

export { REQUESTOR_REQUIRED_FIELDS } from "./bondFormValidationHelpers";

/** Principal name from basicInformation fields (guardianship / VA / probate). */
export function buildPrincipalNameSaveName(globalState) {
  return [
    globalState?.basicInformation?.firstName,
    globalState?.basicInformation?.middleName,
    globalState?.basicInformation?.lastName,
    globalState?.basicInformation?.suffix,
  ]
    .filter(Boolean)
    .join(" ");
}

/** First + last name fallback for support requests. */
export function buildFirstLastSupportName(globalState) {
  return (
    [globalState?.basicInformation?.firstName, globalState?.basicInformation?.lastName]
      .filter(Boolean)
      .join(" ") || "Unknown"
  );
}

/**
 * Factory for per-step required fields with shared guest + attorney append rules.
 */
export function buildRequiredFieldsPerStepFactory({
  baseFieldsByStep,
  skipAttorneyOnGuestStep = 3,
  appendAttorneyOnStep = 3,
  appendHighBondOnStep,
}) {
  return ({ step, data, state, isGuestRequest }) => {
    if (step === skipAttorneyOnGuestStep && isGuestRequest) return [];
    const fields = [...(baseFieldsByStep[step] || [])];
    if (step === appendAttorneyOnStep) appendAttorneyRequiredFields(fields, data);
    if (appendHighBondOnStep != null && step === appendHighBondOnStep) {
      appendHighBondAuthField(fields, step, state);
    }
    return fields;
  };
}
